// BUILD-046 pass F1 (Owner direction 2026-10-25): Work groups belong under administration, not under My Work.
//
// What this candidate has: the sidebar's "HQ administration" entry (/admin), shown to the owner and admin groups, which is the Document Manager (knowledge uploads). It has no people / user
// administration - that is BUILD-039's, in another lineage. So Work groups is hosted as a SECOND TAB of that one administration area, beside Documents; no new top-level section and no
// copy of any other Admin code. Each tab is shown by ITS OWN authority and nothing else: Documents to the owner and admin groups (as /admin always was), Work groups to the Work_Group_Administrator
// (`GET /work/me` canAdministerGroups, admin.users.manage). The server still checks both on every request; the tabs are a convenience. Moving the entry widens nothing: a person who may administer
// groups but is not in the owner / admin groups is led to /work-groups by the sidebar entry and sees no Documents tab.
// Pure functions, erasable TypeScript, no imports.

export type AdminTabKey = 'documents' | 'groups';

export interface AdminTab {
  key: AdminTabKey;
  to: string;
  label: string;
}

export interface AdminTabsInput {
  /** The Caller is in the owner or admin group (shows Documents, as before). */
  isAdmin: boolean;
  /** `GET /work/me` canAdministerGroups. */
  canAdministerGroups: boolean;
}

export function buildAdminTabs(input: AdminTabsInput): AdminTab[] {
  return [
    // BUILD-046 integration: in the HQ source /admin is the HQ administration page (the pilot's candidate had only the Document Manager there), so the first tab carries that name; the key is unchanged.
    ...(input.isAdmin ? [{ key: 'documents' as const, to: '/admin', label: 'HQ administration' }] : []),
    ...(input.canAdministerGroups ? [{ key: 'groups' as const, to: '/work-groups', label: 'Work groups' }] : []),
  ];
}

/** The tab strip is drawn only where there is something to switch between. */
export function showAdminTabs(tabs: readonly AdminTab[]): boolean {
  return tabs.length >= 2;
}
